import {
  FACEBOOK,
  FACEBOOK_GROUP,
  GOOGLE,
  IMPRESSIONS,
  INSTAGRAM,
  LINKEDIN_BUSINESS_PAGE,
  LINKEDIN_PERSONAL_ACCOUNT,
  REACH,
  REACTIONS,
  TIKTOK_BUSINESS_PAGE,
  TIKTOK_PERSONAL_ACCOUNT,
  TWITTER,
  YOUTUBE,
  PINTEREST,
  OVERVIEW_FOLLOWERS_KEY,
  OVERVIEW_FOLLOWER_KEY
} from '../constants';

export const overviewCardConfig = {
  [FACEBOOK]: {
    plot_name: 'profile_followers',
    key: FACEBOOK,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [INSTAGRAM]: {
    plot_name: 'profile_followers',
    key: INSTAGRAM,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [FACEBOOK_GROUP]: {
    plot_name: 'group_members',
    key: FACEBOOK_GROUP,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [TWITTER]: {
    plot_name: 'profile_followers',
    key: TWITTER,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [LINKEDIN_BUSINESS_PAGE]: {
    plot_name: 'profile_followers',
    key: LINKEDIN_BUSINESS_PAGE,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [LINKEDIN_PERSONAL_ACCOUNT]: {
    plot_name: 'profile_followers',
    key: LINKEDIN_PERSONAL_ACCOUNT,
    hasDetails: false,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [GOOGLE]: {
    plot_name: 'profile_views',
    key: GOOGLE,
    hasDetails: true,
    useSum:true,
    dataDelay1Day: true,
    translation_key_multiple: 'dashboard.overview.profile_visits',
    translation_key_single: 'dashboard.overview.profile_visit'
  },
  [YOUTUBE]: {
    plot_name: 'profile_followers',
    key: YOUTUBE,
    hasDetails: false,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [TIKTOK_PERSONAL_ACCOUNT]: {
    plot_name: 'profile_followers',
    key: TIKTOK_PERSONAL_ACCOUNT,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [TIKTOK_BUSINESS_PAGE]: {
    plot_name: 'profile_followers',
    key: TIKTOK_BUSINESS_PAGE,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  },
  [PINTEREST]: {
    plot_name: 'profile_followers',
    key: PINTEREST,
    hasDetails: true,
    translation_key_multiple: OVERVIEW_FOLLOWERS_KEY,
    translation_key_single: OVERVIEW_FOLLOWER_KEY
  }
};
export const overallDevelopmentCardConfig = {
  [REACH]: {
    plot_name: 'virtual_overview',
    key: 'reach',
    title: 'Reach',
    icon: 'fa-duotone fa-earth-americas',
    info_text: 'reach_info_text'
  },
  [IMPRESSIONS]: {
    plot_name: 'virtual_overview',
    key: IMPRESSIONS,
    title: 'post_impressions',
    icon: 'fa-duotone fa-eye',
    info_text: 'impressions_info_text'
  },
  [REACTIONS]: {
    plot_name: 'virtual_overview',
    key: REACTIONS,
    title: 'post_reactions',
    icon: 'fa-duotone fa-heart',
    info_text: 'reactions_info_text'
  },
  posts_per_day_plot: {
    plot_name: 'posts_per_day_plot',
    key: 'posts_per_day_plot',
    title: 'posts_per_day',
    icon: 'fa-duotone fa-clipboard',
    info_text: 'posts_per_day_info_text'
  }
  // posts_per_day: {
  //   plot_name: 'posts_saved_in_lomavis',
  //   key: 'posts_per_day',
  //   title: 'saved_posts_per_day',
  //   icon: 'fa-duotone fa-clipboard',
  //   info_text: 'saved_posts_per_day_info_text'
  // }
};
